// module_configs/electronics.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faMicrochip, faUsersCog, faClock,
  faBuildingColumns
} from '@fortawesome/free-solid-svg-icons';

// Import Electronics components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import ElectronicsProducts from '.././module_electronics/electronics_products';

import ElectronicsProductsList from '.././module_electronics/electronics_productslist';

import ElectronicsPurchases from '.././module_electronics/electronics_Purchases';

import ElectronicsPurchaseList from '.././module_electronics/electronics_PurchaseList';

import ElectronicsReturn from '.././module_electronics/electronics_Return';

import ElectronicsReturnList from '.././module_electronics/electronics_returnlist';

import ElectronicsSell from '.././module_electronics/electronics_Sell';

import ElectronicsSalesList from '.././module_electronics/electronics_SellList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '../module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import ElectronicsSupplierPurchases from '../module_electronics/electronics_PurchasesSupplierwise';
import ElectronicsInvoicePurchaseList from '../module_electronics/electronics_InvoicePurchaseList';
import MechanicsAccounts from '../module_cosmetics/cosmetics_Accounts';
import MechanicsCashLedger from '../module_cosmetics/cosmetics_CashLedger';

export const electronicsConfig = {
  moduleId: 'electronics',
  moduleName: 'Electronics',
  icon: faMicrochip,
  description: 'Electronics Shop Management System',
  i18n: {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'ur', 'ps', 'ar', 'tr', 'fa', 'prs'],
    rtlLanguages: ['ur', 'ps', 'ar', 'fa', 'prs']
  },
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_electronics': { level: 1, label: 'Admin', color: '#0ea5e9' },
    'manager_electronics': { level: 2, label: 'Manager', color: '#0284c7' },
    'user_electronics': { level: 3, label: 'User', color: '#0369a1' },
    'viewer_electronics': { level: 4, label: 'Viewer', color: '#075985' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'sales', name: 'Sales & Sales Returns', icon: faCartShopping, order: 2 },
    { id: 'inventory', name: 'Stock & Inventory', icon: faBoxes, order: 3 },
    { id: 'accounts', name: 'Accounts & Transactions', icon: faBuildingColumns, order: 4 },
    { id: 'billing', name: 'Billing & Renewals', icon: faFileInvoice, order: 5 },
    { id: 'settings', name: 'Settings', icon: faCog, order: 6 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_electronics', 'manager_electronics'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_electronics', 'manager_electronics']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_electronics', 'manager_electronics']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: ElectronicsProducts,
          icon: faCube,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: ElectronicsProductsList,
          icon: faListAlt,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: ElectronicsPurchases,
          icon: faCartPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: ElectronicsPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: ElectronicsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: ElectronicsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Sales Returns',
      aliases: ['sale_return', 'sales_return', 'salereturn', 'salesreturns', 'electronics_return'],
      icon: faArrowRotateLeft,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'sales',
      position: 1,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Sales Return',
          aliases: ['add_sale_return', 'new_sale_return', 'electronics_return'],
          component: ElectronicsReturn,
          icon: faRotateLeft,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'returnlist',
          label: 'Sales Return List',
          aliases: ['sale_return_list', 'sales_return_list', 'electronics_returnlist'],
          component: ElectronicsReturnList,
          icon: faListCheck,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: ElectronicsSell,
          icon: faCartPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: ElectronicsSalesList,
          icon: faClipboardList,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
   {
            id: 'financials',  // or 'accounting'
            label: 'Financials',  // or 'Accounting'
            icon: faMoneyBillWave,
            roles: ['admin_electronics', 'manager_electronics'],
            groupId: 'accounts',
            position: 0,
            submenus: [
              {
                id: 'newtransaction',
                label: 'New Transaction',
                component: AddTransactionForm,
                icon: faPlus,
                roles: ['admin_electronics', 'manager_electronics']
              },
              {
                id: 'alltransactions',
                label: 'All Transactions',
                component: CosmeticsTransactions,
                icon: faMoneyBillWave,
               roles: ['admin_electronics', 'manager_electronics']
              },
              {
                id: 'accounts',
                label: 'Accounts',
                component: MechanicsAccounts,
                icon: faBuildingColumns, // or faUniversity
     roles: ['admin_electronics', 'manager_electronics']
              },
              {
                id: 'cashledger',
                label: 'Cash & Bank Ledger',
                component: MechanicsCashLedger,
                icon: faMoneyBillWave,
              roles: ['admin_electronics', 'manager_electronics']
              }
            ]
          },
    // {
    //   id: 'barcode',
    //   label: 'Barcodes',
    //   icon: faQrcode,
    //   roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
    //   groupId: 'inventory',
    //   position: 9,
    //   submenus: [
    //     {
    //       id: 'barcodeprinting',
    //       label: 'Barcode Printing',
    //       component: MechanicsBarcode,
    //       icon: faPrint,
    //       roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
    //     }
    //   ]
    // },
    {
      id: 'billing',
      label: 'Billing & Renewals',
      aliases: ['billing', 'renewals', 'billing_renewals'],
      icon: faFileInvoice,
      roles: ['admin_electronics', 'manager_electronics'],
      groupId: 'billing',
      position: 0,
      submenus: [
        { id: 'generatebill', label: 'Generate Bill', component: null, icon: faPlus, roles: ['admin_electronics', 'manager_electronics'] },
        { id: 'billinghistory', label: 'Billing History', component: null, icon: faReceipt, roles: ['admin_electronics', 'manager_electronics'] },
        { id: 'renewals', label: 'Renewals', component: null, icon: faArrowRotateLeft, roles: ['admin_electronics', 'manager_electronics'] }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_electronics'],
      groupId: 'settings',
      position: 0,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'settings',
      position: 1,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$2,450' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 234 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 112 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 5 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard', menuId: 'dashboard' },
    { key: 'Alt + C', description: 'Customers', menuId: 'customers' },
    { key: 'Alt + Shift + A', description: 'Add Customer', menuId: 'customers', submenuId: 'addcustomer' },
    { key: 'Alt + Shift + B', description: 'Customer List', menuId: 'customers', submenuId: 'customerlist' },
    { key: 'Alt + S', description: 'Suppliers', menuId: 'suppliers' },
    { key: 'Alt + Shift + C', description: 'Add Supplier', menuId: 'suppliers', submenuId: 'addsupplier' },
    { key: 'Alt + Shift + D', description: 'Supplier List', menuId: 'suppliers', submenuId: 'supplierlist' },
    { key: 'Alt + E', description: 'Employees', menuId: 'employees' },
    { key: 'Alt + Shift + E', description: 'Add Employee', menuId: 'employees', submenuId: 'addemployees' },
    { key: 'Alt + Shift + F', description: 'Employees List', menuId: 'employees', submenuId: 'employeeslist' },
    { key: 'Alt + A', description: 'Sales', menuId: 'sales' },
    { key: 'Alt + Shift + G', description: 'New Sale', menuId: 'sales', submenuId: 'addsale' },
    { key: 'Alt + Shift + H', description: 'Sales List', menuId: 'sales', submenuId: 'saleslist' },
    { key: 'Alt + R', description: 'Sales Returns', menuId: 'returns' },
    { key: 'Alt + Shift + I', description: 'New Sales Return', menuId: 'returns', submenuId: 'addreturn' },
    { key: 'Alt + Shift + J', description: 'Sales Return List', menuId: 'returns', submenuId: 'returnlist' },
    { key: 'Alt + K', description: 'Stock', menuId: 'stock' },
    { key: 'Alt + Shift + K', description: 'Add Stock', menuId: 'stock', submenuId: 'addstock' },
    { key: 'Alt + Shift + L', description: 'Stock List', menuId: 'stock', submenuId: 'stocklist' },
    { key: 'Alt + U', description: 'Purchases', menuId: 'purchases' },
    { key: 'Alt + Shift + M', description: 'New Purchase', menuId: 'purchases', submenuId: 'addpurchase' },
    { key: 'Alt + Shift + N', description: 'Purchases List', menuId: 'purchases', submenuId: 'purchaselist' },
    { key: 'Alt + Shift + O', description: 'Supplier-wise Purchases', menuId: 'purchases', submenuId: 'purchasessupplierwise' },
    { key: 'Alt + Shift + P', description: 'Bill-wise Purchases', menuId: 'purchases', submenuId: 'purchasesinvoicewise' },
    { key: 'Alt + F', description: 'Financials', menuId: 'financials' },
    { key: 'Alt + Shift + Q', description: 'New Transaction', menuId: 'financials', submenuId: 'newtransaction' },
    { key: 'Alt + Shift + R', description: 'All Transactions', menuId: 'financials', submenuId: 'alltransactions' },
    { key: 'Alt + Shift + S', description: 'Accounts', menuId: 'financials', submenuId: 'accounts' },
    { key: 'Alt + Shift + T', description: 'Cash & Bank Ledger', menuId: 'financials', submenuId: 'cashledger' },
    { key: 'Alt + L', description: 'Billing & Renewals', menuId: 'billing' },
    { key: 'Alt + Shift + U', description: 'Generate Bill', menuId: 'billing', submenuId: 'generatebill' },
    { key: 'Alt + Shift + V', description: 'Billing History', menuId: 'billing', submenuId: 'billinghistory' },
    { key: 'Alt + Shift + W', description: 'Renewals', menuId: 'billing', submenuId: 'renewals' },
    { key: 'Alt + O', description: 'Settings', menuId: 'settings' },
    { key: 'Alt + V', description: 'Notifications Center', menuId: 'systemupdates' },
    { key: 'Escape', description: 'Hide or show sidebar', action: 'toggleSidebar' },
    { key: 'Alt + J', description: 'Open or close shop switcher', action: 'toggleShopSwitcher' },
    { key: 'Alt + M', description: 'Change to next theme color', action: 'cycleTheme' },
    { key: 'Alt + X', description: 'Switch dark or light mode', action: 'toggleDarkMode' },
    { key: 'Alt + Q', description: 'Focus menu search', action: 'focusSearch' },
    { key: 'Alt + Y', description: 'Change to next language', action: 'cycleLanguage' },
    { key: 'Alt + H', description: 'Show or hide keyboard shortcuts', action: 'toggleShortcuts' }
  ]
};
